import { render, staticRenderFns } from "./modalpengesahan.vue?vue&type=template&id=6f02b018&scoped=true&"
import script from "./modalpengesahan.vue?vue&type=script&lang=js&"
export * from "./modalpengesahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f02b018",
  null
  
)

export default component.exports